<template>
<div>
  <el-dialog
    :title="title"
    width="80%"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-row>
      <el-col :span="12">
        <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
                label-width="120px">
          <el-row  :gutter="15">
            <el-col :span="12">
                <el-form-item label="中文名称：" prop="">
                  <span>{{ inputForm.nameCn }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="英文名称：" prop="">
                  <span>{{ inputForm.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="物品编码：" prop="">
                  <span>{{ inputForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="分类：" prop="">
                  <span>{{ inputForm.category.name  }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="当前物品类别：" prop="itemPeroperty">
                  <span>{{ inputForm.category.parentIdsName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="价格：" prop="price">
                  <span>{{ $mathUtil.mathToFixed(inputForm.price) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="库存单位：" prop="unit">
                  <span>{{ inputForm.units.unitEn }}</span>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
                <el-form-item label="属性：" prop="itemPeroperty">
                  <span>{{ setItemPeropertyText(inputForm.itemPeroperty) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="描述：" prop="description">
                  <span>{{ inputForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="padding-left: 0px;padding-right: 0px;">
   
              <el-form :model="jsonStr" ref="jsonStr" :class="method==='view'?'readonly':''"
                  :disabled="method==='view'" label-width="142px">
                  <el-col :span="24" style="padding-left: 0px;padding-right: 0px;" v-for="field in fieldList2" :key="field.id">
                    <el-form-item  style="display: none;" :prop="field.id + '.fieldType'">
                      <!-- <el-input v-model="jsonStr[field.id].fieldType">{{field.itemAgileField.fieldType}}</el-input> -->
                    </el-form-item>
                    <template v-if="field.itemAgileField!='' && !field.itemAgileField == false">
                      <el-col :span="field.itemAgileField.haveUnit=='1'||field.itemAgileField.fieldType=='3'?16:12" :style="field.itemAgileField.haveUnit=='1'||field.itemAgileField.fieldType=='3'?'display: contents;':''">
                        <template v-if="field.itemAgileField!='' && field.itemAgileField.fieldType=='3'">
                          <el-form-item style="float: left; padding-left: 7.5px;"
                            :rules="(isNotRequire(field))?[{validator: validator.isFloatGtZero, trigger:'blur'}]:[ {required: true, message:'不能为空', trigger:'blur'},
                              {validator: validator.isFloatGtZero, trigger:'blur'} ]" :prop="field.id + '.en'">
                              <span slot="label">
                                {{field.nameEn}}
                                <template v-if="field.note!=''">
                                  <!-- <el-popover placement="top" title="填写内容注解：" width="150" trigger="hover">
                                    <label>{{ field.note }}</label>
                                    <el-button size="medium" slot="reference" :disabled="false" type="text" icon="el-icon-info"></el-button>
                                  </el-popover> -->
                                </template>
                              </span>
                            <el-input class="inline-input" :style="field.itemAgileField.haveUnit=='1'?'width: 100px !important;':'width: 185px !important;'" 
                            v-model="jsonStr[field.id].en" placeholder="数字1" clearable></el-input> ~ 
                          </el-form-item>
                          <el-form-item style="float: left;"
                              :rules="(isNotRequire(field))?[{validator: validator.isFloatGtZero, trigger:'blur'}]:[ {required: true, message:'不能为空', trigger:'blur'},
                              {validator: validator.isFloatGtZero, trigger:'blur'} ]" :prop="field.id + '.ch'" label-width="5px">
                            <el-input class="inline-input" 
                            :style="field.itemAgileField.haveUnit=='1'?'width: 100px !important;':'width: 185px !important;'" 
                            v-model="jsonStr[field.id].ch" placeholder="数字2" clearable></el-input>
                          </el-form-item>
                        </template>
                        <template v-else-if="field.itemAgileField.fieldType=='2'">
                          
                          <el-form-item style="float: left; padding-left: 7.5px;"
                            :rules="(isNotRequire(field)||isNumNotRequire)?[{validator: validator.isFractionAndCustom, trigger:'blur'}]:[ {required: true, message:'不能为空', trigger:'blur'},
                              {validator: validator.isFractionAndCustom, trigger:'blur'} ]" :prop="field.id + '.en'">
                            <span slot="label">
                              {{field.nameEn}}
                              <!-- <template v-if="field.note!=''">
                                <el-popover placement="top" title="填写内容注解：" width="150" trigger="hover">
                                    <label>{{ field.note }}</label>
                                  <el-button size="medium" slot="reference" :disabled="false" type="text" icon="el-icon-info"></el-button>
                                </el-popover>
                              </template> -->
                            </span>
                            <div class="content-box">
                              <!-- <el-input :ref="field.id+'en'"
                              style="width: 100% !important; min-height:36px !important; 
                                min-width:100px; resize: horizontal; overflow: hidden;" 
                              v-model="jsonStr[field.id].en" :placeholder="field.nameEn" clearable>
                              </el-input>
                              <div class="bar" @mousedown="down($event, field.id+'en')"></div> -->
                              <span>{{ jsonStr[field.id].en }}</span>
                            </div>
                          </el-form-item>
                        </template>
                        <template v-else>
                          <el-form-item :span="24"
                            :rules="(isNotRequire(field))?[]:[ {required: true, message:'不能为空', trigger:'blur'},
                            { min: 1, message: '最小长度是1个字符', trigger: 'blur' } ]" :prop="field.id + '.en'">
                            <span slot="label">
                              {{field.nameEn}}
                              <!-- <template v-if="field.note!=''">
                                <el-popover placement="top" title="填写内容注解：" width="150" trigger="hover">
                                  <label>{{ field.note }}</label>
                                  <el-button size="medium" slot="reference" :disabled="false" type="text" icon="el-icon-info"></el-button>
                                </el-popover>
                              </template> -->
                            </span>
                            <div class="content-box">
                              <!-- <el-autocomplete class="inline-input" popper-class="my-autocomplete" 
                              style="width: 100% !important; min-height:36px !important; 
                              min-width:100px; resize: horizontal; overflow: hidden;" 
                              :ref="field.id+'en'"
                              v-model="jsonStr[field.id].en" :placeholder="field.nameEn"
                              :fetch-suggestions="((queryString,cb)=>{ querySearch2(queryString, cb, field.id, 'en') })" @select="selectField2($event, field.id, 'en')" clearable>
                              <template slot-scope="{ item }">
                                  <div class="name">{{ item.en }}</div>
                                  <span class="addr">{{ item.ch }}</span>
                                </template>
                              </el-autocomplete> -->
                              <span>{{ jsonStr[field.id].en }}</span>
                              <!-- <div class="bar" @mousedown="down($event, field.id+'en')"></div> -->
                            </div>
                          </el-form-item>
                        </template>
                        <!-- 单位 -->
                        <template v-if="field.itemAgileField.haveUnit=='1'">
                          <el-form-item :prop="field.id + '.unit'" style="float:left;" label-width="10px"
                            :rules="(isNotRequire(field)||isNumNotRequire)?[]:[ {required: true, message:'不能为空', trigger:'blur'}]">
                            <!-- <el-select v-model="jsonStr[field.id].unit" placeholder="请选择单位"  
                            :clearable="isNotRequire(field)||isNumNotRequire?true:false"
                            :ref="field.id + 'unit'"
                            @change="changeUnit(jsonStr[field.id], field.id, jsonStr[field.id].en, $event)" :key="field.id" style="width:120px">
                              <el-option v-for="item in getUnitList(field.itemAgileField.unitCategory)" :key="item.id" 
                              :label="item.unitEn+'（'+item.unit+'）'" :value="item.id"> </el-option>
                            </el-select> -->
                            <span>{{  BackUnitName(getUnitList(field.itemAgileField.unitCategory), jsonStr[field.id].unit) }}</span>

                          </el-form-item>
                        </template>
                        <!-- <div v-else style="width: 170px;float:left;visibility: hidden;">ddd</div> -->
                      </el-col>
                      <el-col :span="12" v-if="field.itemAgileField.fieldType=='1'">
                        <el-form-item :prop="field.id + '.ch'" label-width="108px" :span="24">
                          <span slot="label">
                            {{field.name}}
                            <!-- <template v-if="field.note!=''">
                              <el-popover placement="top" title="填写内容注解：" width="150" trigger="hover">
                                <label>{{ field.note }}</label>
                                <el-button size="medium" slot="reference" :disabled="false" type="text" icon="el-icon-info"></el-button>
                              </el-popover>
                            </template> -->
                          </span>
                          <div class="content-box">
                            <!-- <el-autocomplete class="inline-input" popper-class="my-autocomplete" :ref="field.id + 'ch'"
                            style="width: 100% !important;min-height:36px !important;
                            min-width:100px; resize: horizontal; overflow: hidden;"
                            v-model="jsonStr[field.id].ch" :placeholder="field.name" 
                            :fetch-suggestions="((queryString,cb)=>{ querySearch2(queryString, cb, field.id, 'ch') })"  
                            @select="selectField2($event, field.id, 'ch')" clearable>
                              <template slot-scope="{ item }">
                                <div class="name">{{ item.ch }}</div>
                                <span class="addr">{{ item.en }}</span>
                              </template>
                            </el-autocomplete> -->
                            <span>{{ jsonStr[field.id].ch }}</span>
                            <!-- <div class="bar" @mousedown="down($event, field.id + 'ch')"></div> -->
                          </div>
                        </el-form-item>
                      </el-col>
                    </template>
                  </el-col>
              </el-form>
            </el-col>
            </el-row>
        </el-form>
      </el-col>
      <el-col :span="12">
        <ImageColumn :imageArray="inputForm.picJsonList" :code="inputForm.code"></ImageColumn>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecItemService from '@/api/cecitem/cecItemService'
  import ImageColumn from '@/components/imageColumn'
  import cecItemFieldService from '@/api/cecitemfield/cecItemFieldService'
  import cecItemUnitService from '@/api/cecitemunit/cecItemUnitService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          parentId: '',
          code: '',
          categoryId: '',
          price: 0,
          unit: '',
          picture: '',
          name: '',
          nameCn: '',
          itemPeroperty: '',
          jsonStr: '',
          description: '',
          variateRemarks: '',
          variatePics: '',
          isMain: '',
          picJson: '',
          picJsonList: [],
          category: {
            name: '',
            parentIdsName: ''
          },
          units: {
            unitEn: ''
          },
          urlHearder: '',
          parentCode: '',
          mainItem: [],
          mainItemId: '',
          mainItemName: '',
          mainItemNameCn: '',
          mainItemPicture: '',
          mainItemPrice: ''
        },
        fieldList2: [],
        jsonStr: {},
        unitAllList: []
      }
    },
    components: {
      ImageColumn
    },
    methods: {
      BackUnitName (data, type) {
        let findData = data.find(item => item.id === type)
        return findData ? findData.unitEn + ' (' + findData.unit + ')' : ''
      },
      getUnitAllList () {
        cecItemUnitService.noPermissionList({
          'current': 1,
          'size': 1000
        }).then(({data}) => {
          this.unitAllList = data.records
        })
      },
      getUnitList (unitCategory) {
        let units = []
        this.unitAllList.forEach(item => {
          if (item.unitCategory === unitCategory) {
            units.unshift(item)
          }
        })
        return units
      },
      // 定制类C000物品，不需要校验，规格属性允许为空值
      isNotRequire (field) {
        let code = this.inputForm.code
        if (this.inputForm.parentId !== '0' && this.inputForm.isCustomized === '1' && code.toUpperCase().indexOf('C000') !== -1) {
          return true
        }
        if (field.isRequired === '1') {
          return false
        }
        return true
      },
      getItemVarateField () {
        this.fieldList2 = []
        this.jsonStr = {}
        cecItemFieldService.listN({
          'current': 1,
          'itemId': this.inputForm.parentId === '0' ? this.inputForm.id : this.inputForm.parentId
        }).then(({data}) => {
          if (data) {
            this.fieldList2 = data.records
            this.fieldList2.forEach(element => {
              element.isSupplierRequired = '0'
              element.isSupplierCannotInput = '0'
              element.isSupplierDisplay = '0'
              if (element.itemAgileField === '') {
                this.$set(this.inputForm, element.id, {en: '', ch: '', unit: '', fieldType: ''})
              } else {
                this.$set(this.jsonStr, element.id, {en: '', ch: '', unit: '', fieldType: element.itemAgileField ? element.itemAgileField.fieldType : ''})
              }
            })
            if (this.inputForm.jsonStr !== '') {
              this.jsonStr = this.recover(this.jsonStr, JSON.parse(this.inputForm.jsonStr))
            }
          }
        })
        // this.$http({
        //   url: '/cec/property/management/item/itemField/list',
        //   method: 'get',
        //   params: {
        //     'pageNo': 1,
        //     'pageSize': -1,
        //     'orderBy': 'sort asc',
        //     'item.id': this.inputForm.parentId
        //   }
        // }).then(({data}) => {
        //   if (data && data.success) {
        //     this.fieldList2 = data.page.list;
        //     this.fieldList2.forEach(element => {
        //       element.isSupplierRequired='0';
        //       element.isSupplierCannotInput='0';
        //       element.isSupplierDisplay='0';
        //       if(element.itemAgileField == ''){
        //         this.$set(this.inputForm, element.id, {en:"",ch:"",unit:"",fieldType:""});
        //       }else{
        //         this.$set(this.jsonStr, element.id, {en:"",ch:"",unit:"",fieldType:element.itemAgileField.fieldType});
        //       }
        //     });
        //     if(this.inputForm.jsonStr != ''){
        //       this.jsonStr = this.recover(this.jsonStr, JSON.parse(this.inputForm.jsonStr));
        //     }
        //   }
        // })
      },
      init (method, data) {
        this.getUnitAllList()
        this.urlHearder = localStorage.getItem('imageDomainName')
        this.method = method
        this.inputForm.id = data.id
        this.parentCode = data.parentCode
        if (method === 'add') {
          this.title = `新建材料表`
        } else if (method === 'edit') {
          this.title = '修改材料表'
        } else if (method === 'view') {
          this.title = '材料详情'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecItemService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              if (data.parentId === '0') {
                if (this.inputForm.picJson) {
                  this.inputForm.picJsonList = JSON.parse(this.inputForm.picJson).map(citem => {
                    citem.fileUrl = this.urlHearder + citem.fileStorePath + '/' + citem.filesIn
                    return citem
                  })
                } else {
                  if (this.inputForm.mainItemPicture) {
                    let splitData = this.inputForm.mainItemPicture.split('|')
                    this.inputForm.picJsonList = splitData.map(citem => {
                      let itemUP = {
                        fileStorePath: 'item/' + data.mainItemCode + '/' + citem,
                        filesIn: citem,
                        remarks: '',
                        fileUrl: this.urlHearder + 'item/' + data.mainItemCode + '/' + citem
                      }
                      return itemUP
                    })
                  } else {
                    let splitData = this.inputForm.picture.split('|')
                    this.inputForm.picJsonList = splitData.map(citem => {
                      let itemUP = {
                        fileStorePath: 'item/' + data.code + '/' + citem,
                        filesIn: citem,
                        remarks: '',
                        fileUrl: this.urlHearder + 'item/' + data.code + '/' + citem
                      }
                      return itemUP
                    })
                  }
                }
              } else {
                if (this.inputForm.picture) {
                  let splitData = this.inputForm.picture.split('|')
                  this.inputForm.picJsonList = splitData.map(citem => {
                    let itemUP = {
                      fileStorePath: 'item/' + data.code + '/' + citem,
                      filesIn: citem,
                      remarks: '',
                      fileUrl: this.urlHearder + 'item/' + data.code + '/' + citem
                    }
                    return itemUP
                  })
                }
              }
              this.loading = false
              this.getItemVarateField()
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecItemService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      },
      setItemPeropertyText (value) {
        if (!value) return
        let itemPeropertyList = value.split(',')
        let mapArray = itemPeropertyList.map(item => {
          let findDate = this.$dictUtils.getDictList('cec_item_property').find(fitem => fitem.value === item)
          return findDate ? findDate.label : ''
        })
        return mapArray.join(',')
      }
    }
  }
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
</style>